<template>
  <el-dialog :visible.sync="visible">
    <h3 class="title">—— 领取优惠券 ——</h3>
    <div class="coupons_wrap">
      <div class='list'>
        <div v-for='(item, index) in itemcouponsList' class="coupon_each">
          <div class='coupon' v-if='Percentage((item.total*10000-item.receive*10000)/10000,item.total) != "0%"'>
            <div class='coupon_left'>
              <div class='tip' v-if='item.rules == "{}"'>
                <img :src='jbImg.green'>
                <div class='txt'>通</div>
              </div>
              <div :class='item.rules == "{}" ? "price" : "price1"' v-if='item.couponType == 0'>
                <div class='txt2' v-if='numberLength(item.value) <= 3'><span class='txt1'>￥</span>{{item.value}}</div>
                <div class='txt2' v-if='numberLength(item.value) > 3' style='font-size:40px;top:10px'>{{item.value}}</div>
              </div>
              <div class='price_discount' v-if='item.couponType == 1'>
                <div class='txt1'>{{discountCoupon(item.value, 10)}}<span class='txt2'>折</span></div>
              </div>
              <div class='detail'>
                <div class='detail_title'>{{item.title}}</div>
                <div class='detail_desc'>
                  <div class='txt3' v-if='item.amount == 0'>无门槛</div>
                  <div class='txt3' v-else>消费满{{item.amount}}可用</div>
                  <div class='txt4' v-if='item.rangeType == 1 && item.isShowBeginDate'>有效期从{{getCurrentTime(item.rangeBeginTime)}}至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 1 && !item.isShowBeginDate'>有效期至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 0'>领取后{{item.rangeExpiry}}天内有效</div>
                </div>
              </div>
            </div>
            <div class='coupon_right'
              @click="getCoupon(item.id, item.userMax)"
              v-if='item.isReceive == null || (item.isReceive >=0 && item.isReceive < item.userMax)'>
            <!-- <div class='coupon_right' v-if='item.isReceive == null || (item.isReceive >=0 && item.isReceive < item.userMax)' bindtap='getCoupon' data-id='{{item.id}}' data-user-max='{{item.userMax}}'>   -->
              <div>{{ item.couponId }}</div>
              <div class='percent'>{{Percentage((item.total*10000-item.receive*10000)/10000,item.total)}}</div>
              <div class='progress'>
                <img :src='greenImg.hundred' v-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 90  && percentNum((item.total*10000-item.receive*10000)/10000,item.total) <= 100'>
                <img :src='greenImg.ninety' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 80'>
                <img :src='greenImg.eighty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 70'>
                <img :src='greenImg.seventy' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 60'>
                <img :src='greenImg.sixty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 50'>
                <img :src='greenImg.fifty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 40'>
                <img :src='greenImg.forty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 30'>
                <img :src='greenImg.thirty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 20'>
                <img :src='greenImg.twenty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 10'>
                <img :src='greenImg.ten' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) > 0'>
              </div>
              <div class='btn' v-if='item.isReceive == 0 || item.isReceive == null'>立即领取</div>
              <div class='btn' v-else-if='item.isReceive > 0 && item.isReceive < item.userMax'>继续领取</div>
            </div>
            <div class='coupon_right' v-else>
              <div class='percent_grey'>
                {{Percentage((item.total*10000-item.receive*10000)/10000,item.total)}}
              </div>
              <div class='progress'>
                <img :src='greyImg.hundred' v-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 90  && percentNum((item.total*10000-item.receive*10000)/10000,item.total) <= 100'>
                <img :src='greyImg.ninety' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 80'>
                <img :src='greyImg.eighty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 70'>
                <img :src='greyImg.seventy' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 60'>
                <img :src='greyImg.sixty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 50'>
                <img :src='greyImg.fifty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 40'>
                <img :src='greyImg.forty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 30'>
                <img :src='greyImg.thirty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 20'>
                <img :src='greyImg.twenty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 10'>
                <img :src='greyImg.ten' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) > 0'>
              </div>
              <div class='btn_grey'>已领取</div>
            </div>
          </div>
          <div class='coupon_grey' v-else>
            <div class='coupon_left'>
              <div class='tip' v-if='item.rules == "{}"'>
                <img :src='jbImg.grey'>
                <div class='txt'>通</div>
              </div>
              <div :class='item.rules == "{}" ? "price" : "price1"' v-if='item.couponType == 0'>
                <div class='txt2' v-if='numberLength(item.value) <= 3'><span class='txt1'>￥</span>{{item.value}}</div>
                <div class='txt2' v-if='numberLength(item.value) > 3' style='font-size:40px;top:10px'>{{item.value}}</div>
              </div>
              <div class='price_discount' v-if='item.couponType == 1'>
                <div class='txt1'>{{discountCoupon(item.value,10)}}<span class='txt2'>折</span></div>
              </div>
              <div class='detail'>
                <div class='detail_title'>{{item.title}}</div>
                <div class='detail_desc'>
                  <div class='txt3' v-if='item.amount == 0'>无门槛</div>
                  <div class='txt3' v-else>消费满{{item.amount}}可用</div>
                  <div class='txt4' v-if='item.rangeType == 1 && item.isShowBeginDate'>有效期从{{getCurrentTime(item.rangeBeginTime)}}至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 1 && !item.isShowBeginDate'>有效期至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 0'>领取后{{item.rangeExpiry}}天内有效</div>
                </div>
              </div>
            </div>
            <div class='coupon_right'>
              <div class='percent'>0%</div>
              <div class='progress'>
                <img :src='greyImg.zero'>
              </div>
              <div class='btn'>已抢完</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="weui-loadmore" v-if='itemcouponsList.length'>
        <div class="weui-loadmore__tips" style='opacity:0.5'>---我是有底线的---</div>
      </div> -->
    </div>
    <div class="dialog_footer">
      <router-link to="/mine/myCoupons" class="myCoupons">我的优惠券</router-link>
      <router-link to="/couponsCenter" class="couponsCenter">领券中心</router-link>
    </div>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import { getCookie, Percentage, discountCoupon, percentNum, numberLength, getCurrentTime } from "../util/util"

  export default {
    name: "coupons-detail",
    data() {
      return {
        visible: false,
        itemcouponsList: [],
        jbImg:{
          'green':'https://pic.jianyanwang.com/upload/20181126/bc448451fdb04948baa69ccc6ded84ae.png',
          'grey': 'https://pic.jianyanwang.com/upload/20181126/b1b843cee3af44eca9a473b3a5ed9f68.png'
        },
        greenImg:{
          'ten':'https://pic.jianyanwang.com/upload/20180910/0eec567b8ddc4dd6bb97ad238e2d171c.png',
          'twenty':'https://pic.jianyanwang.com/upload/20180910/c54f4b6eb4e04153a1d718b4fb422552.png',
          'thirty':'https://pic.jianyanwang.com/upload/20180910/3476a26864444d0bbc362be279b86d18.png',
          'forty':'https://pic.jianyanwang.com/upload/20180910/bed08d7f01a741a18c222484f092e13c.png',
          'fifty':'https://pic.jianyanwang.com/upload/20180910/86fcbebaebcb4501ae85c54692a10cfe.png',
          'sixty':'https://pic.jianyanwang.com/upload/20180910/741d3dfb9c82447487ab3ce82e31bcf8.png',
          'seventy':'https://pic.jianyanwang.com/upload/20180910/6db26d7ac2fd444ba8a799e50d41709b.png',
          'eighty':'https://pic.jianyanwang.com/upload/20180910/09b2a76a088a45beb0267d5ad1c6bd41.png',
          'ninety':'https://pic.jianyanwang.com/upload/20180910/e9c50505bdc941bba21a28cb293d5921.png',
          'hundred':'https://pic.jianyanwang.com/upload/20180910/3a89f88e06c7495fb9765d7fa586b8b7.png'
        },
        greyImg:{
          'zero':'https://pic.jianyanwang.com/upload/20180910/494b3b6becd142a8b77acbe7439da417.png',
          'ten':'https://pic.jianyanwang.com/upload/20180910/8fa789a4cb4c4ab79e258c239f14b444.png',
          'twenty':'https://pic.jianyanwang.com/upload/20180910/67a7b72bd14e411598a78dc0b0516f5f.png',
          'thirty':'https://pic.jianyanwang.com/upload/20180910/f53d37edb6d34e1985d74ea741213ca3.png',
          'forty':'https://pic.jianyanwang.com/upload/20180910/72262d24148a4a298aac46811525c0ca.png',
          'fifty':'https://pic.jianyanwang.com/upload/20180910/0b03042ad4d94b0981f089ad67b4fdb2.png',
          'sixty':'https://pic.jianyanwang.com/upload/20180910/963127e06c77404bb301f52c7b6a4971.png',
          'seventy':'https://pic.jianyanwang.com/upload/20180910/91abdc6fdd7744c48fb3b939b8572629.png',
          'eighty':'https://pic.jianyanwang.com/upload/20180910/6c702aa216094733bd1e2530c754ede1.png',
          'ninety':'https://pic.jianyanwang.com/upload/20180910/d2179d31739a4f5c9a9445495ce13891.png',
          'hundred':'https://pic.jianyanwang.com/upload/20180910/fb85d95aeef646c285b5076aaf2c2c97.png'
        },
      }
    },
    computed: {
      Percentage () {
        return function (number1, number2) {
          return Percentage(number1, number2)
        }
      },
      discountCoupon () {
        return function (number1, number2) {
          return discountCoupon(number1, number2)
        }
      },
      percentNum () {
        return function (number1, number2) {
          return percentNum(number1, number2)
        }
      },
      numberLength () {
        return function (number) {
          return numberLength(number)
        }
      },
      getCurrentTime () {
        return function (time) {
          return getCurrentTime(time)
        }
      }
    },
    methods: {
      init (itemId) {
        this.itemId = itemId
        this.visible = true
        console.log('itemId', itemId)
        if (getCookie("_token")) {
          console.log('登录')
          this.getItemcouponsList(itemId)
        } else {
          console.log('未登录')
          this.getItemcouponsList_unlogin(itemId)
        }
      },
      //获取项目可用优惠券(未登录)
      getItemcouponsList_unlogin(itemId) {
        var itemType = itemId.toString().indexOf('a') == -1 ? 0 : 1
        var id = itemId.toString().split('a').join("")
        axios.get('/ai/coupon/item/nologin', {
          params: {
            platform: 'ZYJY',
            itemId,
            itemType
          }
        }).then((res) => {
          console.log('res', res)
          if (res.data.code == 0) {
            this.itemcouponsList = res.data.list
            var itemcouponsList = res.data.list
            var curDate = new Date().getTime()
            for (var i = 0; i < itemcouponsList.length; i++) {
              if (itemcouponsList[i].rangeEndTime) {
                itemcouponsList[i].rangeEndTime = itemcouponsList[i].rangeEndTime.replace(/-/g, '/')
                itemcouponsList[i].rangeBeginTime = itemcouponsList[i].rangeBeginTime.replace(/-/g, '/')
                var endDate = Date.parse(new Date(itemcouponsList[i].rangeEndTime))
                var beginDate = Date.parse(new Date(itemcouponsList[i].rangeBeginTime))
                if ((beginDate - curDate) > 0) {
                  itemcouponsList[i].isShowBeginDate = true
                } else {
                  itemcouponsList[i].isShowBeginDate = false
                }
              }
            }
          }
        })
      },
      //获取项目可用优惠券(登录)
      getItemcouponsList(itemId) {
        console.log('itemId', itemId)
        var itemType = itemId.toString().indexOf('a') == -1 ? 0 : 1
        var id = itemId.toString().split('a').join("")
        axios.get('/ai/coupon/item', {
          params: {
            platform: 'ZYJY',
            itemId,
            itemType
          }
        }).then((res) => {
          console.log('获取项目可用优惠券 res', res)
          if (res.data.code == 0) {
            this.itemcouponsList = res.data.list
            var itemcouponsList = res.data.list
            var curDate = new Date().getTime()
            console.log('itemcouponsList.length', itemcouponsList.length)
            for (var i = 0; i < itemcouponsList.length; i++) {
              if (itemcouponsList[i].rangeEndTime) {
                itemcouponsList[i].rangeEndTime = itemcouponsList[i].rangeEndTime.replace(/-/g, '/')
                itemcouponsList[i].rangeBeginTime = itemcouponsList[i].rangeBeginTime.replace(/-/g, '/')
                var endDate = Date.parse(new Date(itemcouponsList[i].rangeEndTime))
                var beginDate = Date.parse(new Date(itemcouponsList[i].rangeBeginTime))
                if ((beginDate - curDate) > 0) {
                  itemcouponsList[i].isShowBeginDate = true
                } else {
                  itemcouponsList[i].isShowBeginDate = false
                }
              }
            }
          }
        })
      },
      // 领券
      getCoupon(couponId, userMax) {
        if (!getCookie("_token")) {
          // console.log('未登录')
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          })
          this.visible = false
          // this.p_showLoginModal()
        } else {
          // console.log('领取')
          axios.post('/ai/coupon/' + couponId).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: '领取成功',
                type: 'success'
              })
              this.init(this.itemId)
            } else {
              this.$message.error('领取失败')
            }
          })
        }
      },
    }
  }
</script>

<style scoped>
  /deep/ .el-dialog {
    width: 30%!important;
  }

  /deep/ .el-dialog__body{
    padding: 0 20px 30px 20px;
  }
  h3.title{
    text-align: center;
    padding: 10px 0 20px 0;
  }
  .title{
    font-size: 18px;
    font-weight: bold;

  }
  p{
    line-height: 30px;
    text-indent:2em
  }

  .dialog_footer {
    margin-top:50px;
    display: flex;
    justify-content: center;
  }

  .myCoupons {
    width: 110px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #00C5B0;
    border-radius: 4px;
    color: #fff;
  }

  .couponsCenter {
    width: 110px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #fff;
    border-radius: 4px;
    color: #000;
    border: 1px solid #ccc;
    margin-left: 30px;
  }
</style>

<style scoped>
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }
  }
</style>

<style scoped>
/* PC */
/* loadmore */
.weui-loadmore {
  width: 65%;
  margin: 3.5em auto;
  line-height: 1.6em;
  font-size: 14px;
  text-align: center;
}

.weui-loadmore__tips {
  display: inline-block;
  vertical-align: middle;
  color: #888;
}

.coupons_main {
  display: flex;
  width: 100%;
}

.regulation{
  width:100%;
  height:72px;
  line-height: 72px;
  background: #F5F5F5;
  text-align: center;
}
.regulation text{
  padding-right: 30px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #576B95;
}

.list{
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  /* margin-top: 40px; */
  margin: 0 auto;
}

.coupon_each {
  flex: 1 0 100%;
}

.list .coupon,
.list .coupon_grey{
  display: flex;
  width: 93%;
  /* width: 670px; */
  height: 130px;
  margin: 0 auto;
  background :#FFFFFF;
  margin-top: 40px;
  box-shadow:3px 3px 20px #d8d8d8;
}


.list .coupon .coupon_left,
.list .coupon_grey .coupon_left{
  width: 75%;
  height: 100%;
  /* overflow: hidden; */
  position: relative;
  display: flex;
}
.list .coupon .coupon_left .tip,
.list .coupon_grey .coupon_left .tip{
  width: 50px;
  height: 50px;
  position: absolute;
}
.list .coupon .coupon_left .tip img,
.list .coupon_grey .coupon_left .tip img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0
}
.list .coupon .coupon_left .tip .txt,
.list .coupon_grey .coupon_left .tip .txt{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  position: absolute;
  top: 3px;
  left: 6px;
  /* z-index: 99 */
}
.list .coupon .coupon_left .price,
.list .coupon_grey .coupon_left .price{
  width: 50%;
  height: 100%;
}
.list .coupon .coupon_left .price .txt1,
.list .coupon_grey .coupon_left .price .txt1{
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #00C5B0;
  /* padding-left: 28px; */
}
.list .coupon .coupon_left .price .txt2,
.list .coupon_grey .coupon_left .price .txt2{
  font-family: DINCondensed-Bold;
  font-size: 40px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  height: 100%;
  line-height: 300%;
  text-align: center;

  /* padding-left: 12px; */
}
.list .coupon .coupon_left .price1,
.list .coupon_grey .coupon_left .price1{
  width: 50%;
  height: 100%;
  float: left;
  position: relative
}
.list .coupon .coupon_left .price1 .txt1,
.list .coupon_grey .coupon_left .price1 .txt1{
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #00C5B0;
  /* padding-left: 28px; */
}
.list .coupon .coupon_left .price1 .txt2,
.list .coupon_grey .coupon_left .price1 .txt2{
  height: 100%;
  line-height: 300%;
  text-align: center;
  font-family: DINCondensed-Bold;
  font-size: 40px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  /* padding-left: 12px; */
  /* margin-left:60px; */
}
.list .coupon .coupon_left .price_discount,
.list .coupon_grey .coupon_left .price_discount{
  display: flex;
  align-items: right;
  width: 50%;
  height: 100%;
  line-height: 250%;
}
.list .coupon .coupon_left .price_discount .txt1,
.list .coupon_grey .coupon_left .price_discount .txt1{
  width: 100%;
  height: 100%;
  line-height: 300%;
  font-family: DINCondensed-Bold;
  font-size: 40px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  text-align: center;
}
.list .coupon .coupon_left .price_discount .txt2,
.list .coupon_grey .coupon_left .price_discount .txt2{
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #00C5B0;
  padding-left: 8px;
  font-weight: bold;
}
.list .coupon .coupon_left .detail,
.list .coupon_grey .coupon_left .detail{
  width: 80%;
  height:100%;
}

.list .coupon .coupon_left .detail .detail_title,
.list .coupon_grey .coupon_left .detail .detail_title{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353535;
  line-height: 15px;
  margin:30px 0 5px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.list .coupon .coupon_left .detail  .detail_desc text,
.list .coupon_grey .coupon_left .detail  .detail_desc text{
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #888888;
  /* line-height: 22px; */
}

.list .coupon .coupon_right,
.list .coupon_grey .coupon_right{
    width: 25%;
    height: 100%;
    text-align: center;
    position: relative;
    border-left:4px dotted #ddd;
    cursor: pointer;
}
.list .coupon .coupon_right::before,
.list .coupon .coupon_right::after,
.list .coupon_grey .coupon_right::before,
.list .coupon_grey .coupon_right::after{
    content: '';
    width: 24px;
    height: 24px;
    position: absolute;
    left: -12px;
    background: #f5f5f5;
    border-radius:12px;
}
.list .coupon .coupon_right::before,
.list .coupon_grey .coupon_right::before{
    top:-12px;
    box-shadow: inset 0 -4px 6px #d8d8d8;
}
.list .coupon .coupon_right::after,
.list .coupon_grey .coupon_right::after{
    bottom:-12px;
    box-shadow: inset 0 4px 6px #d8d8d8;

}
.list .coupon .coupon_right .progress,
.list .coupon_grey .coupon_right .progress{
  width: 32px;
  height: 65px;
  margin:0 auto;

}
.list .coupon .coupon_right .progress img,
.list .coupon_grey .coupon_right .progress img{
  width: 24px;
  height: 65px;
}
.list .coupon .coupon_right .percent,
.list .coupon_grey .coupon_right .percent{
  width:100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #00C5B0;
  text-align: center;
  line-height: 12px;
  margin-top: 12px;
}
.list .coupon .coupon_right .percent_grey,
.list .coupon_grey .coupon_right .percent_grey{
  width:100%;
  font-family: PingFangSC-Medium;
  font-size: 8px;
  color: #B2B2B2;
  text-align: center;
  line-height: 12px;
  margin-top: 12px;
}
.list .coupon .coupon_right .btn,
.list .coupon_grey .coupon_right .btn{
  width: 75%;
  height: 22px;
  line-height: 22px;
  margin:0 auto;
  margin-top: 5px;
  background: #FE2042;
  border-radius: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  border-color: #FE2042;
  letter-spacing: 0;
  font-weight: 300;
  text-align: center;
  padding: 0 0;
}
.list .coupon .coupon_right .btn_grey,
.list .coupon_grey .coupon_right .btn_grey{
  width: 75%;
  height: 22px;
  line-height: 22px;
  margin:0 auto;
  margin-top: 5px;
  background: #B2B2B2;
  border-radius: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
}

/*已抢完的优惠券*/
.list .coupon_grey{
  background: #F5F5F5;
}

.list .coupon_grey .coupon_left .price .txt1,
.list .coupon_grey .coupon_left .price1 .txt1,
.list .coupon_grey .coupon_left .price_discount .txt1,
.list .coupon_grey .coupon_left .price .txt2,
.list .coupon_grey .coupon_left .price1 .txt2,
.list .coupon_grey .coupon_left .price_discount .txt2,
.list .coupon_grey .coupon_left .detail .detail_title,
.list .coupon_grey .coupon_left .detail  .detail_desc text,
.list .coupon_grey .coupon_right .percent{
  color: #B2B2B2;
}

.list .coupon_grey .coupon_right .btn{
  background: #E2E2E2;
  color: #B2B2B2;
  border-color: #E2E2E2;
}

.index_icon{
  width:124px;
  height: 124px;
  position:fixed;
  right:15px;
  bottom:130px;
  z-index: 999;
}
.index_icon .icon_img{
  width:124px;
  height: 124px;
}
/* 底部按钮 */
.footer{
  width:100%;
  height:146px;
  position:fixed;
  z-index: 111;
  bottom:0px;
  background-img: linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, #FFFFFF 13%);
}

</style>

<style scoped>
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .coupon_each {
    flex: 1 0 100%;
  }

  .list{
    width: 100%;
  }

  .list .coupon,
  .list .coupon_grey{
    width: 100%;
  }

  .list .coupon .coupon_left,
  .list .coupon_grey .coupon_left {
    display: flex;
    height: 100%;
    position: relative;
  }

  .list .coupon .coupon_left .price,
  .list .coupon_grey .coupon_left .price{
    width: 85%;
    height: 100%;
    padding-right: 5%;
    margin-right: 0;
  }

  .list .coupon .coupon_left .price_discount,
  .list .coupon_grey .coupon_left .price_discount{
    display: flex;
    text-align: center;
    width: 85%;
    height: 100%;
    padding-right: 5%;
    margin-right: 0;
  }

  .list .coupon .coupon_left .price_discount .txt1,
  .list .coupon_grey .coupon_left .price_discount .txt1{
    width: 100%;
    height: 100%;
    line-height: 333%;
    font-family: DINCondensed-Bold;
    font-size: 32px;
    color: #00C5B0;
    letter-spacing: -1.87px;
    text-align: center;
  }

  .list .coupon .coupon_right,
  .list .coupon_grey .coupon_right{
    width: 35%;
    height: 100%;
    text-align: center;
    position: relative;
    border-left:4px dotted #ddd;
    cursor: pointer;
  }

  .list .coupon .coupon_left .detail .detail_title,
  .list .coupon_grey .coupon_left .detail .detail_title{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #353535;
    line-height: 15px;
    margin: 30px 0 25px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .list .coupon .coupon_left .price .txt1,
  .list .coupon_grey .coupon_left .price .txt1{
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #00C5B0;
  }

  .list .coupon .coupon_left .price .txt2,
  .list .coupon_grey .coupon_left .price .txt2{
    height: 100%;
    line-height: 333%;
    font-family: DINCondensed-Bold;
    font-size: 32px;
    color: #00C5B0;
    letter-spacing: -1.87px;
    text-align: center;
  }

  .txt3, .txt4 {
    font-size: 12px;
  }

  .list .coupon .coupon_left .price1,
  .list .coupon_grey .coupon_left .price1{
    width: 65%;
    height: 100%;
    padding-right: 5%;
    margin-right: 0;
    position: relative
  }

  .list .coupon .coupon_left .price1 .txt1,
  .list .coupon_grey .coupon_left .price1 .txt1{
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #00C5B0;
  }

  .list .coupon .coupon_left .price1 .txt2,
  .list .coupon_grey .coupon_left .price1 .txt2{
    font-family: DINCondensed-Bold;
    font-size: 32px;
    color: #00C5B0;
    letter-spacing: -1.87px;
    height: 100%;
    line-height: 333%;
    text-align: center;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/coupons-detail.vue